// src/pages/MediHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const MediHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("MediFinders");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const groupNames = [
    // { label: "Talking Label", emoji: "🩺🔊" },          
    // { label: "MeetTheDoctor", emoji: "👨‍⚕️💬" },        
    { label: "MediFinders", emoji: "🔍" }, 
    { label: "MediBox", emoji: "💊" }, 
    { label: "GrowthLoop", emoji: "🌈" }, 
    { label: "Lifescience LnD", emoji: "🧬" },         
    { label: "MediSense Productivity", emoji: "📈" },  
    { label: "Clinical Governance", emoji: "⚖️🩺" },
    { label: "Clinical Operations", emoji: "⚙️" },
    { label: "Health Data Exchange", emoji: "📡" },
    { label: "MediSense CCM", emoji: "📅" },           
    { label: "MRWorld", emoji: "🧑‍💼" },               
    { label: "Self Reflection", emoji: "🪞" },  
    { label: "MediDocs", emoji: "📋" },  
    { label: "MediSense DeepTech", emoji: "🧠" },  
    { label: "Digital Income", emoji: "💰" },         
  ];

  const menuButtons1 = [
    // Talking Label   
    { label: "Talking Label", emoji: "🩺🔊", link: "/talkinglabels", group: "Talking Label" },

    // MeetTheDoctor    
    { label: "MeetTheDoctor", emoji: "👨‍⚕️💬", link: "/meetthedoctor", group: "MeetTheDoctor" },

    // MediBox   
    { label: "MediBox", emoji: "💊", link: "/medibox", group: "MediBox" },

    //growthloop
     { label: "GrowthLoop", emoji: "🌈", link: "/growthloop", group: "GrowthLoop" },

    // MediFinders    
    { label: "MedicineFinder", emoji: "🔍💊", link: "/medicinefinder", group: "MediFinders" },
    { label: "beSure Medicines", emoji: "🛡️💊", link: "/besure", group: "MediFinders" },
    { label: "beSure Devices", emoji: "🛡️🩻", link: "/besure", group: "MediFinders" },
    { label: "beSure Consumables", emoji: "🛡️🧪", link: "/besure", group: "MediFinders" },
    { label: "Consultants", emoji: "🧑‍⚕️🧠", link: "/think5whys-counsellors", group: "MediFinders" },
    { label: "Second Opinion", emoji: "🩺🔄", link: "/secondopinion", group: "MediFinders" },
    { label: "New Medicines", emoji: "🧬✨", link: "/newmedicines", group: "MediFinders" },

    // 📚 Lifescience LnD
    { label: "Immersive Medical Learning", emoji: "🧬🎓", link: "/medisense-bookworld", group: "Lifescience LnD" },
    { label: "MediSense Bookshelf", emoji: "📚🧠", link: "/bookshelf", group: "Lifescience LnD" },
    { label: "Trainings & Workshops", emoji: "🎓🩺", link: "/enroll/workshop", group: "Lifescience LnD" },
    { label: "Podcast", emoji: "🎙️🧠", link: "/podcast-mylist", group: "Lifescience LnD" },
    { label: "mediTube", emoji: "▶️📺", link: "/meditube", group: "Lifescience LnD" },
    { label: "Clinical Trial Literacy", emoji: "🧪📘", link: "/clinical-trials", group: "Lifescience LnD" },
    { label: "Pharma Compliance Training", emoji: "🏛️💊", link: "/pharma-compliance", group: "Lifescience LnD" },
    { label: "Medical Writing", emoji: "✍️🧬", link: "/medical-writing", group: "Lifescience LnD" },
    { label: "Real World Evidence", emoji: "🌍📊", link: "/real-world-evidence", group: "Lifescience LnD" },

    // MediSense Productivity
    { label: "MediSense Ranking", emoji: "🏆📊", link: "/medisensescore", group: "MediSense Productivity" },
    { label: "MediSense Database", emoji: "🗄️💾", link: "/medisensedb", group: "MediSense Productivity" },
    { label: "Self Assessment", emoji: "🧠📋", link: "/medisense-selfassessment", group: "MediSense Productivity" },
    { label: "DeepThinking Lab", emoji: "🔬🧠", link: "/fivewhys-analysis-home", group: "MediSense Productivity" },
    { label: "MediSense Chronicles", emoji: "📖🧩", link: "/medisense-business-chronicles", group: "MediSense Productivity" },
    { label: "Patient Diary", emoji: "📔❤️", link: "/mydiary-home", group: "MediSense Productivity" },
    { label: "Pet Diary", emoji: "📔🐾", link: "/mydiary-home", group: "MediSense Productivity" },
    { label: "Journal", emoji: "🗒️✍️", link: "/myjournal-home", group: "MediSense Productivity" },
    { label: "Kanban", emoji: "📋⚙️", link: "/medisense-kanban", group: "MediSense Productivity" },
    { label: "TwiWorld", emoji: "🌐💬", link: "/twiworld", group: "MediSense Productivity" },
    { label: "Treatment Adherence", emoji: "⏰💊", link: "/treatment-adherence", group: "MediSense Productivity" },
    { label: "Outcome Tracker", emoji: "📊❤️", link: "/outcome-tracker", group: "MediSense Productivity" },
    { label: "Symptom Checker AI", emoji: "🩺🤖", link: "/symptom-checker", group: "MediSense Productivity" },

    // ⚖️🩺 Clinical Governance & Compliance
    { label: "Clinical Guidelines", emoji: "📜🩺", link: "/clinical-guidelines", group: "Clinical Governance" },
    { label: "Ethics & Consent", emoji: "🤝📄", link: "/ethics-consent", group: "Clinical Governance" },
    { label: "Medical Audit", emoji: "🧐📊", link: "/medical-audit", group: "Clinical Governance" },
    { label: "Incident Reporting", emoji: "🚨📝", link: "/incident-reporting", group: "Clinical Governance" },
    { label: "Regulatory Updates", emoji: "🏛️📰", link: "/regulatory-updates", group: "Clinical Governance" },

    // 🏥📋 Hospital & Clinical Operations
    { label: "OPD Workflow", emoji: "👥🩺", link: "/opd-workflow", group: "Clinical Operations" },
    { label: "IPD Care Pathway", emoji: "🛏️🩺", link: "/ipd-care", group: "Clinical Operations" },
    { label: "Discharge Summary AI", emoji: "📄🤖", link: "/discharge-summary", group: "Clinical Operations" },
    { label: "Clinical Handover", emoji: "🔄🩺", link: "/clinical-handover", group: "Clinical Operations" },
    { label: "Bed & Resource Planning", emoji: "🛏️📊", link: "/bed-planning", group: "Clinical Operations" },

    // 🧑‍💼📒 MRWorld    
    { label: "MR Book", emoji: "📒🧑‍💼", link: "/medisense-kanban", group: "MRWorld" },
    { label: "Minutes of Meeting", emoji: "✍️📄", link: "/tasks/add", group: "MRWorld" },
    { label: "Call Effectiveness AI", emoji: "📈🤖", link: "/call-effectiveness", group: "MRWorld" },
    { label: "Doctor Segmentation", emoji: "👨‍⚕️🧠", link: "/doctor-segmentation", group: "MRWorld" },
    { label: "Objection Handling", emoji: "🗣️🛡️", link: "/objection-handling", group: "MRWorld" },
    { label: "Product Knowledge Hub", emoji: "💊📚", link: "/product-knowledge", group: "MRWorld" },

    // 🔐📡 Health Data & Interoperability
    { label: "Health Records Vault", emoji: "🗄️🔐", link: "/health-vault", group: "Health Data Exchange" },
    { label: "FHIR Integration", emoji: "🔄📑", link: "/fhir", group: "Health Data Exchange" },
    { label: "Consent Manager", emoji: "✅📜", link: "/consent-manager", group: "Health Data Exchange" },
    { label: "ABDM Bridge", emoji: "🇮🇳🩺", link: "/abdm", group: "Health Data Exchange" },

    // 🔄 MediSense CCM (Contacts. Communication. Meetings)
    { label: "Own Digital Card", emoji: "💼📇", link: "/medisense-digitalcard", group: "MediSense CCM" },
    { label: "Client Digital Card", emoji: "👤📇", link: "/contact-genious-clientcards", group: "MediSense CCM" },
    { label: "Own Speaking Card", emoji: "🎙️📇", link: "/contact-genious-speakingcard", group: "MediSense CCM" },
    { label: "Card Visibility", emoji: "👁️📊", link: "/contact-genious-cardviewstats", group: "MediSense CCM" },
    { label: "Meeting Calendar", emoji: "📅🤝", link: "/calendar-list", group: "MediSense CCM" },
    { label: "Visits", emoji: "📍🚶‍♂️", link: "/visits-list", group: "MediSense CCM" },
    { label: "Meeting Thoughts", emoji: "💭🧠", link: "/thoughts-list", group: "MediSense CCM" },
    { label: "Meeting TODO", emoji: "✅📋", link: "/todo-list", group: "MediSense CCM" },
    { label: "Meeting Tasks", emoji: "🛠️📋", link: "/tasks-list", group: "MediSense CCM" },
    { label: "Travel", emoji: "🚗🗺️", link: "/travels-list", group: "MediSense CCM" },
    { label: "Checklist", emoji: "📋✔️", link: "/checklist-list", group: "MediSense CCM" },
    { label: "Meeting Record", emoji: "🗂️🎙️", link: "/meetings-list", group: "MediSense CCM" },
    { label: "Whisper", emoji: "🤫💬", link: "", group: "MediSense CCM" },
    { label: "Meeting Analytics AI", emoji: "🧠📈", link: "", group: "MediSense CCM" },

    // 🪞 SHELF REFLECTION
    { label: "Self Management", emoji: "🧠🪞", link: "/medisense-self-chronicles", group: "Self Reflection" },
    { label: "Own Year Book", emoji: "📘🗓️", link: "/medisenseyb-home", group: "Self Reflection" },
    { label: "Own Diary", emoji: "📔🖊️", link: "/mydiary-home", group: "Self Reflection" },
    { label: "Own Journal", emoji: "📓🧠", link: "/myjournal-home", group: "Self Reflection" },
    { label: "Own DeepThinking", emoji: "🧩🧠", link: "/fivewhys-analysis-home", group: "Self Reflection" },
    { label: "Own AI Counselling", emoji: "🤖🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "Forum", emoji: "🗣️🌐", link: "/povify-home", group: "Self Reflection" },

    // MediDocs  
    { label: "Documents Locker", emoji: "📁🩺", link: "/docsure-home", group: "MediDocs" },

    // MediSense DeepTech   
    { label: "Ask AI", emoji: "🤖🩺", link: "/agenticsim", group: "MediSense DeepTech" },
    { label: "Neuro Scans", emoji: "🧠🔍", link: "", group: "MediSense DeepTech" },
    { label: "Onco Scans", emoji: "🧬🔬", link: "", group: "MediSense DeepTech" },
    { label: "Dental Scans", emoji: "🦷🔍", link: "", group: "MediSense DeepTech" },
    { label: "Patterns", emoji: "📊🧩", link: "/talkinglabels", group: "MediSense DeepTech" },

    // 💰 DIGITAL INCOME
    // { label: "Monthly Digital Income", emoji: "💻💰", link: "/medisense-bookworld", group: "Digital Income" },
    { label: "My Income Credit", emoji: "🌱", link: "/myincomecredits", group: "Digital Income" },
    { label: "My Income", emoji: "💰", link: "/myincome", group: "Digital Income" },
    { label: "ValueShare", emoji: "🤝💰", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🎯💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Referral Income", emoji: "🔗💵", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Resell", emoji: "♻️💼", link: "/medisense-enroll", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎁📣", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "🎥💰", link: "/orderflow-spotbuy", group: "Digital Income" },
    { label: "Digital Boutique", emoji: "🛒✨", link: "/digiboutique", group: "Digital Income" },
  ];

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">🩺💊 MediSense</div>
          <div className="text-xs text-white">Global Medicine Accessibility & Safety Platform!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-18 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="bg-cyan-800 text-white text-xs lg:text-sm py-2">
        <div className="px-1 flex flex-wrap justify-center gap-2">
          <a href="/medisense-about" className="hover:text-yellow-200">💭 About</a>
          <a href="/meetthedoctor" className="hover:text-yellow-200">👨‍⚕️ MeetTheDoctor</a>
          <a href="/talkinglabels" className="hover:text-yellow-200">🔊 Talking Label</a>
          <a href="/growthloop" className="hover:text-yellow-200">🌈 ADHD+</a>
          <a href="/agenticsim" className="hover:text-yellow-200">🤖 Ask AI</a>      
        </div>
      </div>

      <div className="mt-1 mb-1 px-3 py-2 border-b border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-2  border-gray-600 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-teal-700 text-yellow-200"
                  : "bg-gray-800 text-gray-200 hover:bg-gray-700"
              }`}
              aria-pressed={activeTab === group.label}
            >
              <span className="text-lg">{group.emoji}</span>
              <span className="mt-1 text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 lg:grid-cols-5 gap-1 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-gray-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-[10px] text-xs lg:text-sm font-medium transition bg-transparent hover:bg-teal-700 hover:text-yellow-200 text-gray-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-base sm:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-1 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MediHome;
